import { render } from "./Newsletter.vue?vue&type=template&id=45ae1fcf&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=ts"
export * from "./Newsletter.vue?vue&type=script&lang=ts"

import "./Newsletter.vue?vue&type=style&index=0&id=45ae1fcf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-45ae1fcf"

export default script